import './Unification.css';
import React, { useCallback, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import User from 'utils/user.util';

const Unification = ({ property }) => {
    const { t } = useTranslation();
    const [activeBtn, setActiveBtn] = useState('account');
    const [iframeUrl, setIframeUrl] = useState(null);
    const propertyCode = property?.external_id__c;

    const fetchIframeUrl = useCallback(
        async (type) => {
            setActiveBtn(type);
            try {
                const token = User.getToken();
                const response = await fetch(
                    `${process.env.REACT_APP_PROXY_URL || ''}/api/unification/frame/${type}`,
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error('Failed to fetch iframe URL');
                }

                const data = await response.json();

                // Set the iframe URL from the fetched data
                const urlAndFilter =
                    type === 'account'
                        ? `${data.url}&filter=${encodeURIComponent('property,isdeleted')}&filter_value=${encodeURIComponent(`${propertyCode},false`)}&filter_op=${encodeURIComponent('eq,eq')}&logic_op=or,and`
                        : `${data.url}&filter=${encodeURIComponent('accountid,property,isdeleted')}&filter_value=${encodeURIComponent(`0012E00001ricUhQAI,${propertyCode},false`)}&filter_op=${encodeURIComponent('ne,eq,eq')}&logic_op=and,or,and`;
                setIframeUrl(urlAndFilter);
            } catch (error) {
                console.error('Error fetching iframe URL:', error);
            }
        },
        [propertyCode]
    );

    useEffect(() => {
        fetchIframeUrl('account');
    }, [fetchIframeUrl]);

    return (
        <div>
            <h3 className="m-0">{t('unification')}</h3>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                <Button
                    onClick={() => fetchIframeUrl('account')}
                    style={{ margin: '10px 10px 0 10px' }}
                    className={`btn ${activeBtn === 'account' ? 'btn-dark' : 'btn-light'}`}
                >
                    Accounts
                </Button>
                <Button
                    onClick={() => fetchIframeUrl('contact')}
                    style={{ margin: '10px 10px 0 10px' }}
                    className={`btn ${activeBtn === 'contact' ? 'btn-dark' : 'btn-light'}`}
                >
                    Contacts
                </Button>
            </div>
            {iframeUrl ? (
                <iframe
                    width={'100%'}
                    height={'700px'}
                    src={`${iframeUrl}`}
                    title="unify-iframe"
                ></iframe>
            ) : (
                <></>
            )}
        </div>
    );
};

export default Unification;
